export const SET_USER = 'SET_USER';
export const SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN';
